import { render } from "./ManuscriptResults.vue?vue&type=template&id=632aa0d6&ts=true"
import script from "./ManuscriptResults.vue?vue&type=script&lang=ts"
export * from "./ManuscriptResults.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__